(function() {
  'use strict';

  class RepresentativesState {
    static statesMapping = {
      'AC': 'Acre', 'AL': 'Alagoas', 'AP': 'Amapá', 'AM': 'Amazonas',
      'BA': 'Bahia', 'CE': 'Ceará', 'DF': 'Distrito Federal', 'ES': 'Espírito Santo',
      'GO': 'Goiás', 'MA': 'Maranhão', 'MT': 'Mato Grosso', 'MS': 'Mato Grosso do Sul',
      'MG': 'Minas Gerais', 'PA': 'Pará', 'PB': 'Paraíba', 'PR': 'Paraná',
      'PE': 'Pernambuco', 'PI': 'Piauí', 'RJ': 'Rio de Janeiro', 'RN': 'Rio Grande do Norte',
      'RS': 'Rio Grande do Sul', 'RO': 'Rondônia', 'RR': 'Roraima', 'SC': 'Santa Catarina',
      'SP': 'São Paulo', 'SE': 'Sergipe', 'TO': 'Tocantins'
    };

    static currentFilterState = null;
    static currentFilterType = 'todos';
    static currentSort = 'relevancia';
    static representativesData = [];
    static searchRadius = 10;
    static geocodedCache = {};
    static currentSearchResults = null;
    static abortController = null;
    static isSearching = false;
    static searchDebounceTimeout = null;
    static currentSearchLocation = null;

    static normalizeString(str) {
      if (!str) return '';
      return str.toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim();
    }

    static reset() {
      this.currentFilterState = null;
      this.currentFilterType = 'todos';
      this.currentSort = 'relevancia';
      this.currentSearchResults = null;
      this.currentSearchLocation = null;
        this.abortController = null;
      this.isSearching = false;
      if (this.searchDebounceTimeout) {
        clearTimeout(this.searchDebounceTimeout);
        this.searchDebounceTimeout = null;
      }
    }
  }

  class RepresentativesSearch {
    static init() {
      const searchInput = document.getElementById('ec-representatives-search');
      const locationBtn = document.getElementById('ec-representatives-location-btn');
      
      if (searchInput) {
        RepresentativesState.searchRadius = parseInt(searchInput.getAttribute('data-search-radius')) || 10;

        searchInput.addEventListener('input', (e) => {
          const term = e.target.value.trim();
          
          if (RepresentativesState.searchDebounceTimeout) {
            clearTimeout(RepresentativesState.searchDebounceTimeout);
            RepresentativesState.searchDebounceTimeout = null;
          }
          
          if (RepresentativesState.isSearching) {
            RepresentativesManager.cancelSearch();
            RepresentativesManager.unlockSearchInput();
          }
          
          if (term.length === 0) {
            RepresentativesManager.clearAll();
          } else if (term.length >= 3 || this.isCEP(term)) {
            RepresentativesState.searchDebounceTimeout = setTimeout(() => {
              RepresentativesState.searchDebounceTimeout = null;
              if (!RepresentativesState.isSearching) {
                this.handleSearch(term);
              }
            }, 1000);
          } else {
            RepresentativesState.currentSearchResults = null;
            RepresentativesManager.updateTitle(null, null, 'all-bold');
            RepresentativesManager.initGrid();
          }
        });
      }

      if (locationBtn) {
        RepresentativesState.searchRadius = parseInt(locationBtn.getAttribute('data-search-radius')) || 10;
        locationBtn.addEventListener('click', () => {
          RepresentativesLocation.handleLocationClick();
        });
      }
    }

    static isCEP(value) {
      return /^\d{5}-?\d{3}$/.test(value);
    }

    static matchEstado(searchTerm) {
      const normalized = RepresentativesState.normalizeString(searchTerm);
      
      for (const [uf, nome] of Object.entries(RepresentativesState.statesMapping)) {
        const nomeNormalized = RepresentativesState.normalizeString(nome);
        if (nomeNormalized.includes(normalized) || normalized.includes(nomeNormalized)) {
          return uf;
        }
      }

      return null;
    }

    static buscarRepresentantesPorCidade(cidade) {
      const cidadeNormalized = RepresentativesState.normalizeString(cidade);
      const allCards = document.querySelectorAll('.ec-representative-card-wrapper');
      const results = [];
      
      allCards.forEach(card => {
        const cardCidade = card.getAttribute('data-cidade') || '';
        const cardCidadeNormalized = RepresentativesState.normalizeString(cardCidade);
        
        if (cardCidadeNormalized === cidadeNormalized || 
            cardCidadeNormalized.includes(cidadeNormalized) ||
            cidadeNormalized.includes(cardCidadeNormalized)) {
          results.push(card);
        }
      });

      return results;
    }

    static async buscarRepresentantesPorCEP(cep) {
      try {
        RepresentativesState.abortController = new AbortController();
        const cepClean = cep.replace(/\D/g, '');
        
        const viaCepRes = await fetch(`https://viacep.com.br/ws/${cepClean}/json/`, {
          signal: RepresentativesState.abortController.signal
        });
        
        if (RepresentativesState.abortController.signal.aborted) {
          return [];
        }
        
        const viaCepData = await viaCepRes.json();

        if (!viaCepData.uf || viaCepData.erro) {
          const estadoMatch = this.matchEstado(cep);
          if (estadoMatch) {
            RepresentativesManager.hideLoading();
            return RepresentativesFiltering.buscarRepresentantesPorEstado(estadoMatch);
          }
          RepresentativesManager.hideLoading();
          return [];
        }

        const cidade = viaCepData.localidade;
        
        if (!cidade) {
          RepresentativesManager.hideLoading();
          return [];
        }

        RepresentativesManager.hideLoading();
        return this.buscarRepresentantesPorCidade(cidade);

      } catch (e) {
        if (e.name === 'AbortError') {
          return [];
        }
        console.error('Erro ao buscar por CEP:', e);
        RepresentativesManager.hideLoading();
        return [];
      }
    }

    static async buscarRepresentantesPorEndereco(endereco) {
      try {
        RepresentativesState.abortController = new AbortController();
        const searchTermNormalized = RepresentativesState.normalizeString(endereco);
        const cards = document.querySelectorAll('.ec-representative-card-wrapper');
        const localMatches = [];

        cards.forEach(card => {
          const cardCidade = card.getAttribute('data-cidade') || '';
          const cardEndereco = card.getAttribute('data-endereco') || '';
          
          const cardCidadeNormalized = RepresentativesState.normalizeString(cardCidade);
          const cardEnderecoNormalized = RepresentativesState.normalizeString(cardEndereco);

          if (cardCidadeNormalized.includes(searchTermNormalized) || 
              searchTermNormalized.includes(cardCidadeNormalized) ||
              cardEnderecoNormalized.includes(searchTermNormalized) ||
              searchTermNormalized.includes(cardEnderecoNormalized)) {
            localMatches.push(card);
          }
        });

        if (localMatches.length > 0) {
          return localMatches;
        }

        const geoData = await RepresentativesLocation.geocodeAddress(endereco);
        
        if (!geoData || !geoData.address) {
          return [];
        }

        const cidade = geoData.address.city || 
                      geoData.address.town || 
                      geoData.address.village || 
                      geoData.address.municipality || '';

        if (cidade) {
          return this.buscarRepresentantesPorCidade(cidade);
        }

        return [];

      } catch (e) {
        if (e.name === 'AbortError') {
          return [];
        }
        console.error('Erro ao buscar por endereço:', e);
        return [];
      }
    }

    static async handleSearch(searchTerm) {
      if (!searchTerm || searchTerm.trim() === '') {
        RepresentativesManager.clearAll();
        return;
      }

      RepresentativesManager.cancelSearch();
      RepresentativesManager.showLoading();
      RepresentativesManager.lockSearchInput();
      RepresentativesFiltering.clearFilters();
      RepresentativesState.currentFilterState = null;
      RepresentativesState.currentSearchResults = null;

      const term = searchTerm.trim();
      let results = [];

      try {
        if (this.isCEP(term)) {
          results = await this.buscarRepresentantesPorCEP(term);
          if (results.length === 0) {
            RepresentativesManager.unlockSearchInput();
            RepresentativesManager.hideLoading();
            this.updateSearchResults([], 'Nenhum representante encontrado para este CEP.');
            return;
          }
          RepresentativesState.currentSearchResults = results;
          RepresentativesManager.unlockSearchInput();
          RepresentativesManager.updateTitle(null, term, 'cep');
          this.updateSearchResults(results, `Busca pelo CEP: ${term}`);
          RepresentativesManager.updateCounter(results.length, term);
        } else {
          const estadoMatch = this.matchEstado(term);
          if (estadoMatch) {
            RepresentativesManager.unlockSearchInput();
            RepresentativesManager.hideLoading();
            RepresentativesFiltering.filterByState(estadoMatch);
            RepresentativesManager.updateTitle(estadoMatch, null, 'state');
            return;
          } else {
            results = await this.buscarRepresentantesPorEndereco(term);
            if (results.length === 0) {
              RepresentativesManager.unlockSearchInput();
              RepresentativesManager.hideLoading();
              this.updateSearchResults([], 'Nenhum representante encontrado para este endereço.');
              return;
            }
            RepresentativesState.currentSearchResults = results;
          RepresentativesManager.unlockSearchInput();
          RepresentativesManager.updateTitle(null, term, 'address');
          this.updateSearchResults(results, `Profissionais próximos a ${term}`);
          RepresentativesManager.updateCounter(results.length, term);
          }
        }
      } catch (e) {
        if (e.name === 'AbortError') {
          RepresentativesManager.unlockSearchInput();
          return;
        }
        console.error('Erro na busca:', e);
        RepresentativesManager.unlockSearchInput();
        RepresentativesManager.hideLoading();
        this.updateSearchResults([], 'Erro ao realizar a busca. Tente novamente.');
      }
    }

    static updateSearchResults(results, titleText) {
      RepresentativesManager.hideLoading();
      RepresentativesState.currentSearchResults = results;
      
      if (titleText) {
        const locationMatch = titleText.match(/próximos a (.+)/);
        if (locationMatch) {
          RepresentativesState.currentSearchLocation = locationMatch[1];
        } else {
          RepresentativesState.currentSearchLocation = null;
        }
      }

      RepresentativesManager.applyFilters();
      RepresentativesFiltering.updateClearButton();
      
      if (titleText) {
        if (titleText.startsWith('Busca pelo CEP:')) {
          const cepMatch = titleText.match(/Busca pelo CEP: (.+)/);
          if (cepMatch) {
            RepresentativesManager.updateTitle(null, cepMatch[1].trim(), 'cep');
          }
        } else if (titleText.includes('próximos a')) {
          const addressMatch = titleText.match(/próximos a (.+)/);
          if (addressMatch) {
            RepresentativesManager.updateTitle(null, addressMatch[1].trim(), 'address');
          }
        } else {
          RepresentativesManager.updateTitle(null, titleText);
        }
      }
    }
  }

  class RepresentativesLocation {
    static calcularDistancia(lat1, lon1, lat2, lon2) {
      const R = 6371;
      const dLat = ((lat2 - lat1) * Math.PI) / 180;
      const dLon = ((lon2 - lon1) * Math.PI) / 180;
      const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos((lat1 * Math.PI) / 180) * Math.cos((lat2 * Math.PI) / 180) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      return R * c;
    }

    static async geocodeAddress(address) {
      if (RepresentativesState.geocodedCache[address]) {
        return RepresentativesState.geocodedCache[address];
      }

      try {
        await new Promise((resolve) => setTimeout(resolve, 1000));

        if (RepresentativesState.abortController && RepresentativesState.abortController.signal.aborted) {
          return null;
        }

        const encodedAddress = encodeURIComponent(`${address}, Brasil`);
        const fetchOptions = {
          headers: { 
            'User-Agent': 'Representantes',
            'Accept': 'application/json'
          },
        };

        if (RepresentativesState.abortController) {
          fetchOptions.signal = RepresentativesState.abortController.signal;
        }

        const nominatimRes = await fetch(
          `https://nominatim.openstreetmap.org/search?q=${encodedAddress}&format=json&countrycodes=br&limit=1&addressdetails=1`,
          fetchOptions
        );

        if (RepresentativesState.abortController && RepresentativesState.abortController.signal.aborted) {
          return null;
        }

        if (!nominatimRes.ok) {
          console.warn('Erro na resposta do Nominatim:', nominatimRes.status);
          return null;
        }

        const geoData = await nominatimRes.json();

        if (geoData && geoData.length > 0 && geoData[0].lat && geoData[0].lon) {
          const result = {
            lat: parseFloat(geoData[0].lat),
            lon: parseFloat(geoData[0].lon),
            address: geoData[0].address || {}
          };
          
          if (!isNaN(result.lat) && !isNaN(result.lon)) {
            RepresentativesState.geocodedCache[address] = result;
            return result;
          }
        }
      } catch (e) {
        console.warn('Erro ao geocodificar endereço:', e.message || e);
      }

      return null;
    }

    static async geocodeRepresentativeAddress(card) {
      try {
        const lat = card.getAttribute('data-latitude');
        const lon = card.getAttribute('data-longitude');
        
        if (lat && lon && lat !== '' && lon !== '') {
          return {
            lat: parseFloat(lat),
            lon: parseFloat(lon)
          };
        }

        const endereco = card.getAttribute('data-endereco');
        const cidade = card.getAttribute('data-cidade');
        const estado = card.getAttribute('data-estado');

        if (!endereco || endereco.trim() === '') {
          return null;
        }

        const fullAddress = `${endereco}, ${cidade}, ${estado}, Brasil`;
        const coords = await this.geocodeAddress(fullAddress);

        if (coords) {
          card.setAttribute('data-latitude', coords.lat);
          card.setAttribute('data-longitude', coords.lon);
          return coords;
        }

        return null;
      } catch (e) {
        console.warn('Erro ao geocodificar endereço do representante:', e.message || e);
        return null;
      }
    }

    static async geocodeRepresentativesInParallel(cards, maxConcurrent = 5) {
      if (!cards || cards.length === 0) return;

      const cardsToGeocode = cards.filter(card => {
        const lat = card.getAttribute('data-latitude');
        const lon = card.getAttribute('data-longitude');
        return !lat || !lon || lat === '' || lon === '';
      });

      if (cardsToGeocode.length === 0) return;

      for (let i = 0; i < cardsToGeocode.length; i += maxConcurrent) {
        if (RepresentativesState.abortController && RepresentativesState.abortController.signal.aborted) {
          break;
        }

        const batch = cardsToGeocode.slice(i, i + maxConcurrent);
        const promises = batch.map(card => 
          this.geocodeRepresentativeAddress(card).catch(e => {
            if (e.name !== 'AbortError') {
              console.warn('Erro ao geocodificar representante:', e.message || e);
            }
            return null;
          })
        );

        await Promise.all(promises);

        if (i + maxConcurrent < cardsToGeocode.length) {
          await new Promise((resolve) => setTimeout(resolve, 800));
        }
      }
    }

    static async buscarRepresentantesPorLocalizacao(lat, lon, radius, cidade) {
      try {
        RepresentativesState.abortController = new AbortController();
        
        let cards = Array.from(document.querySelectorAll('.ec-representative-card-wrapper'));

        if (cidade) {
          const cidadeNormalized = RepresentativesState.normalizeString(cidade);
          cards = cards.filter(card => {
          const cardCidade = card.getAttribute('data-cidade') || '';
            const cardCidadeNormalized = RepresentativesState.normalizeString(cardCidade);
            return cardCidadeNormalized.includes(cidadeNormalized) || 
                   cidadeNormalized.includes(cardCidadeNormalized);
          });
        }

        const cardsToGeocode = [];
        const cardsWithCoords = [];

        cards.forEach(card => {
          const cardLat = card.getAttribute('data-latitude');
          const cardLon = card.getAttribute('data-longitude');

          if (cardLat && cardLon && cardLat !== '' && cardLon !== '') {
            cardsWithCoords.push(card);
          } else {
            cardsToGeocode.push(card);
          }
        });

        if (cardsToGeocode.length > 0) {
          await this.geocodeRepresentativesInParallel(cardsToGeocode);
        }

        const allCards = [...cardsWithCoords, ...cardsToGeocode];
        const results = [];

        allCards.forEach(card => {
          const cardLat = parseFloat(card.getAttribute('data-latitude'));
          const cardLon = parseFloat(card.getAttribute('data-longitude'));

          if (!isNaN(cardLat) && !isNaN(cardLon)) {
            const distancia = this.calcularDistancia(lat, lon, cardLat, cardLon);
            if (distancia <= radius) {
              results.push({
                card: card,
                distancia: distancia
              });
            }
          }
        });

        return results.sort((a, b) => a.distancia - b.distancia).map(r => r.card);

      } catch (e) {
        if (e.name === 'AbortError') {
          return [];
        }
        console.error('Erro ao buscar por localização:', e);
        return [];
      }
    }

    static async handleLocationClick() {
      if (!navigator.geolocation) {
        alert('Geolocalização não é suportada pelo seu navegador.');
        return;
      }

      RepresentativesManager.cancelSearch();
      RepresentativesManager.showLoading();
      RepresentativesFiltering.clearFilters();
      RepresentativesState.currentFilterState = null;

      const titleElement = document.querySelector('.ec-representatives-filter__title');
      if (titleElement) {
        titleElement.textContent = 'Buscando representantes próximos à sua localização...';
      }

      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const lat = position.coords.latitude;
          const lon = position.coords.longitude;

          try {
            await new Promise((resolve) => setTimeout(resolve, 1000));

            if (RepresentativesState.abortController && RepresentativesState.abortController.signal.aborted) {
              return;
            }

            RepresentativesState.abortController = new AbortController();
            const nominatimUrl = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}&zoom=18`;
            const nominatimRes = await fetch(nominatimUrl, {
              headers: {
                'User-Agent': 'Representantes',
                'Accept-Language': 'pt-BR,pt;q=0.9,en-US;q=0.8,en;q=0.7',
                'Accept': 'application/json'
              },
              signal: RepresentativesState.abortController.signal
            });

            let localizacao = 'sua localização';
            let cidadeExtraida = '';
            if (nominatimRes.ok) {
              try {
                const locationData = await nominatimRes.json();
                if (locationData && locationData.address) {
                  const cidade = locationData.address.city || 
                                 locationData.address.town || 
                                 locationData.address.village || 
                                 locationData.address.municipality || '';
                  const estado = locationData.address.state || '';
                  if (cidade) {
                    cidadeExtraida = cidade;
                    if (estado) {
                      localizacao = `${cidade}, ${estado}`;
                    } else {
                      localizacao = cidade;
                    }
                  }
                }
              } catch (e) {
                console.warn('Erro ao processar resposta do Nominatim:', e.message || e);
              }
            }

            let results = await this.buscarRepresentantesPorLocalizacao(lat, lon, RepresentativesState.searchRadius, cidadeExtraida);

            if (results.length === 0 && cidadeExtraida) {
              results = RepresentativesSearch.buscarRepresentantesPorCidade(cidadeExtraida);
            }

            RepresentativesManager.hideLoading();

            if (results.length === 0) {
              RepresentativesSearch.updateSearchResults([], `Nenhum representante próximo a ${localizacao}`);
            } else {
              RepresentativesState.currentSearchResults = results;
              RepresentativesManager.updateTitle(null, localizacao, 'address');
              RepresentativesSearch.updateSearchResults(results, `Representantes próximos a ${localizacao}`);
              RepresentativesManager.updateCounter(results.length, localizacao);
            }
          } catch (error) {
            if (error.name === 'AbortError') {
              return;
            }
            console.error('Erro ao obter localização:', error);
            RepresentativesManager.hideLoading();
            RepresentativesSearch.updateSearchResults([], 'Erro ao buscar representantes próximos.');
            setTimeout(() => {
              RepresentativesManager.updateTitle(null, null, 'all-bold');
            }, 1000);
          }
        },
        (error) => {
          RepresentativesManager.hideLoading();
          let errorMessage;
          switch (error.code) {
            case error.PERMISSION_DENIED:
              errorMessage = 'Você precisa permitir o acesso à sua localização.';
              break;
            case error.POSITION_UNAVAILABLE:
              errorMessage = 'Não foi possível determinar sua localização.';
              break;
            case error.TIMEOUT:
              errorMessage = 'O tempo para obter sua localização expirou.';
              break;
            default:
              errorMessage = 'Ocorreu um erro ao obter sua localização.';
          }
          RepresentativesSearch.updateSearchResults([], errorMessage);
          setTimeout(() => {
            RepresentativesManager.updateTitle(null, null, 'all-bold');
          }, 1000);
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0,
        }
      );
    }
  }

  class RepresentativesFiltering {
    static init() {
      this.initStateFilter();
      this.addClearFilterButton();
      this.initTypeFilter();
    }

    static initStateFilter() {
      const filterContainer = document.getElementById('ec-representatives-filter-uf');
      if (!filterContainer) return;

      const UFs = [...new Set(RepresentativesState.representativesData.map(rep => rep.estado).filter(Boolean))].sort();

      if (UFs.length === 0) return;

      filterContainer.innerHTML = UFs.map(uf => 
        `<div class="filter-uf_element" data-value="${uf}">${RepresentativesState.statesMapping[uf] || uf}</div>`
      ).join('');

      const filterElements = filterContainer.querySelectorAll('.filter-uf_element');
      
      filterElements.forEach(el => {
        el.addEventListener('click', () => {
          const ufSelecionada = el.getAttribute('data-value');
          this.filterByState(ufSelecionada);
        });
      });
    }

    static addClearFilterButton() {
      const filterContainer = document.getElementById('ec-representatives-filter-uf');
      if (!filterContainer) return;

      const urlParams = new URLSearchParams(window.location.search);
      const hasFilter = urlParams.get('estado');

      const clearButton = document.createElement('div');
      clearButton.className = 'filter-uf_element';
      clearButton.setAttribute('data-value', '');
      clearButton.textContent = 'Todos';
      
      if (!hasFilter) {
        clearButton.classList.add('active');
      }
      
      clearButton.addEventListener('click', () => {
        this.filterByState(null);
      });

      filterContainer.insertBefore(clearButton, filterContainer.firstChild);
    }

    static clearFilters() {
      document.querySelectorAll('.filter-uf_element.active').forEach(el => {
        el.classList.remove('active');
      });
    }

    static buscarRepresentantesPorEstado(uf) {
      const allCards = document.querySelectorAll('.ec-representative-card-wrapper');
      const results = [];
      
      allCards.forEach(card => {
        const cardEstado = card.getAttribute('data-estado')?.toUpperCase().trim() || '';
        if (uf && cardEstado === uf.toUpperCase().trim()) {
          results.push(card);
        }
      });

      return results;
    }

    static filterByState(uf) {
      RepresentativesManager.cancelSearch();
      this.clearFilters();
      
      const filterElement = document.querySelector(`.filter-uf_element[data-value="${uf || ''}"]`);
      if (filterElement) {
        filterElement.classList.add('active');
      }

      RepresentativesState.currentFilterState = uf;
      RepresentativesState.currentSearchResults = null;
      RepresentativesState.currentSearchLocation = null;
      
      RepresentativesManager.applyFilters();
      if (uf) {
        RepresentativesManager.updateTitle(uf, null, 'state');
      } else {
        RepresentativesManager.updateTitle(null, null, 'all-bold');
      }
      this.updateClearButton();
    }

    static updateClearButton() {
      const clearButton = document.getElementById('ec-representatives-clear-search-btn');
      if (!clearButton) return;

      const hasSearch = RepresentativesState.currentSearchResults && RepresentativesState.currentSearchResults.length > 0;
      const hasLocation = RepresentativesState.currentSearchLocation !== null;
      const hasStateFilter = RepresentativesState.currentFilterState !== null;
      const hasTypeFilter = RepresentativesState.currentFilterType !== 'todos';

      if (hasSearch || hasLocation || hasStateFilter || hasTypeFilter) {
        clearButton.style.display = 'block';
      } else {
        clearButton.style.display = 'none';
      }
    }

    static initTypeFilter() {
      const button = document.getElementById('ec-representatives-type-filter-button');
      const dropdown = document.getElementById('ec-representatives-type-filter-dropdown');
      const modal = document.getElementById('ec-representatives-type-filter-modal');
      const modalClose = document.getElementById('ec-representatives-type-filter-modal-close');
      if (!button) return;
      if (!dropdown && !modal) return;
      
      if (button.hasAttribute('data-initialized')) return;
      button.setAttribute('data-initialized', 'true');

      const isMobile = () => window.innerWidth <= 749;
      const filterContainer = button.closest('[data-type-filter]');

      const toggleDropdown = function() {
        const mobile = isMobile();
        if (mobile) {
          if (modal) {
            const isOpen = modal.getAttribute('aria-hidden') === 'false';
            if (isOpen) {
              modal.setAttribute('aria-hidden', 'true');
              document.body.style.overflow = '';
            } else {
              modal.setAttribute('aria-hidden', 'false');
              document.body.style.overflow = 'hidden';
            }
          }
        } else {
          if (dropdown) {
            const isOpen = button.getAttribute('aria-expanded') === 'true';
            if (isOpen) {
              button.setAttribute('aria-expanded', 'false');
              dropdown.setAttribute('hidden', '');
            } else {
              button.setAttribute('aria-expanded', 'true');
              dropdown.removeAttribute('hidden');
            }
          }
        }
      };

      const closeDropdown = () => {
        if (isMobile()) {
          if (modal) {
            modal.setAttribute('aria-hidden', 'true');
            document.body.style.overflow = '';
          }
        } else {
          if (dropdown) {
            dropdown.setAttribute('hidden', '');
          }
          button.setAttribute('aria-expanded', 'false');
        }
      };

      button.addEventListener('click', function(e) {
        e.stopPropagation();
        toggleDropdown();
      });

      if (modalClose) {
        modalClose.addEventListener('click', closeDropdown);
      }

      if (modal) {
        modal.addEventListener('click', (e) => {
          if (e.target === modal) {
            closeDropdown();
          }
        });
      }

      const selectOption = (value, label) => {
        const valueElement = document.getElementById('ec-representatives-type-filter-value');
        if (valueElement) {
          valueElement.textContent = label;
        }
        
        if (dropdown) {
          const options = dropdown.querySelectorAll('.ec-representatives-type-filter__option');
          options.forEach(opt => {
            opt.classList.remove('ec-representatives-type-filter__option--selected');
            opt.setAttribute('aria-selected', 'false');
            if (opt.getAttribute('data-value') === value) {
              opt.classList.add('ec-representatives-type-filter__option--selected');
              opt.setAttribute('aria-selected', 'true');
            }
          });
        }

        if (modal) {
          const modalOptions = modal.querySelectorAll('.ec-representatives-type-filter__option');
          modalOptions.forEach(opt => {
            opt.classList.remove('ec-representatives-type-filter__option--selected');
            opt.setAttribute('aria-selected', 'false');
            const checkbox = opt.querySelector('.ec-representatives-type-filter__option-checkbox');
            if (checkbox) {
              checkbox.style.backgroundColor = '#FFFFFF';
              checkbox.style.borderColor = '#E8E8EE';
            }
            if (opt.getAttribute('data-value') === value) {
              opt.classList.add('ec-representatives-type-filter__option--selected');
              opt.setAttribute('aria-selected', 'true');
              if (checkbox) {
                checkbox.style.backgroundColor = '#086EBB';
                checkbox.style.borderColor = '#086EBB';
              }
            }
          });
        }
        
        RepresentativesState.currentFilterType = value;
        closeDropdown();
        RepresentativesManager.applyFilters();
        this.updateClearButton();
      };

      if (dropdown) {
        const options = dropdown.querySelectorAll('.ec-representatives-type-filter__option');
        options.forEach(option => {
          option.addEventListener('click', (e) => {
            e.stopPropagation();
            const value = option.getAttribute('data-value');
            const label = option.textContent.trim();
            selectOption(value, label);
          });
        });
      }

      if (modal) {
        const modalOptions = modal.querySelectorAll('.ec-representatives-type-filter__option');
        const currentValue = RepresentativesState.currentFilterType || 'todos';
        modalOptions.forEach(option => {
          const optionValue = option.getAttribute('data-value');
          if (optionValue === currentValue) {
            option.classList.add('ec-representatives-type-filter__option--selected');
            option.setAttribute('aria-selected', 'true');
            const checkbox = option.querySelector('.ec-representatives-type-filter__option-checkbox');
            if (checkbox) {
              checkbox.style.backgroundColor = '#086EBB';
              checkbox.style.borderColor = '#086EBB';
            }
          }
          option.addEventListener('click', (e) => {
            e.stopPropagation();
            const value = option.getAttribute('data-value');
            const label = option.querySelector('span:last-child')?.textContent.trim() || option.textContent.trim();
            selectOption(value, label);
          });
        });
      }

      document.addEventListener('click', function(e) {
        if (filterContainer && !filterContainer.contains(e.target)) {
          closeDropdown();
        }
      });
    }
  }

  class RepresentativesSorting {
    static init() {
      const button = document.getElementById('ec-representatives-sort-button');
      const dropdown = document.getElementById('ec-representatives-sort-dropdown');
      const modal = document.getElementById('ec-representatives-sort-modal');
      const modalClose = document.getElementById('ec-representatives-sort-modal-close');
      if (!button) return;
      
      if (button.hasAttribute('data-initialized')) return;
      button.setAttribute('data-initialized', 'true');

      const isMobile = () => window.innerWidth <= 749;
      const sortContainer = button.closest('[data-sort-filter]');

      const toggleDropdown = () => {
        if (isMobile()) {
          if (modal) {
            const isOpen = modal.getAttribute('aria-hidden') === 'false';
            if (isOpen) {
              modal.setAttribute('aria-hidden', 'true');
              document.body.style.overflow = '';
            } else {
              modal.setAttribute('aria-hidden', 'false');
              document.body.style.overflow = 'hidden';
            }
          }
        } else {
          if (dropdown) {
            const isOpen = button.getAttribute('aria-expanded') === 'true';
            if (isOpen) {
              button.setAttribute('aria-expanded', 'false');
              dropdown.setAttribute('hidden', '');
            } else {
              button.setAttribute('aria-expanded', 'true');
              dropdown.removeAttribute('hidden');
            }
          }
        }
      };

      const closeDropdown = () => {
        if (isMobile()) {
          if (modal) {
            modal.setAttribute('aria-hidden', 'true');
            document.body.style.overflow = '';
          }
        } else {
          if (dropdown) {
            dropdown.setAttribute('hidden', '');
          }
          button.setAttribute('aria-expanded', 'false');
        }
      };

      button.addEventListener('click', function(e) {
        e.stopPropagation();
        toggleDropdown();
      });

      if (modalClose) {
        modalClose.addEventListener('click', closeDropdown);
      }

      if (modal) {
        modal.addEventListener('click', (e) => {
          if (e.target === modal) {
            closeDropdown();
          }
        });
      }

      const selectOption = (value, label) => {
        const valueElement = document.getElementById('ec-representatives-sort-value');
        if (valueElement) {
          valueElement.textContent = label;
        }
        
        if (dropdown) {
          const options = dropdown.querySelectorAll('.ec-representatives-sort__option');
          options.forEach(opt => {
            opt.classList.remove('ec-representatives-sort__option--selected');
            opt.setAttribute('aria-selected', 'false');
            if (opt.getAttribute('data-value') === value) {
              opt.classList.add('ec-representatives-sort__option--selected');
              opt.setAttribute('aria-selected', 'true');
            }
          });
        }

        if (modal) {
          const modalOptions = modal.querySelectorAll('.ec-representatives-sort__option');
          modalOptions.forEach(opt => {
            opt.classList.remove('ec-representatives-sort__option--selected');
            opt.setAttribute('aria-selected', 'false');
            const checkbox = opt.querySelector('.ec-representatives-sort__option-checkbox');
            if (checkbox) {
              checkbox.style.backgroundColor = '#FFFFFF';
              checkbox.style.borderColor = '#E8E8EE';
            }
            if (opt.getAttribute('data-value') === value) {
              opt.classList.add('ec-representatives-sort__option--selected');
              opt.setAttribute('aria-selected', 'true');
              if (checkbox) {
                checkbox.style.backgroundColor = '#086EBB';
                checkbox.style.borderColor = '#086EBB';
              }
            }
          });
        }
        
        RepresentativesState.currentSort = value;
        closeDropdown();
        RepresentativesManager.applyFilters();
      };

      if (dropdown) {
        const options = dropdown.querySelectorAll('.ec-representatives-sort__option');
        options.forEach(option => {
          option.addEventListener('click', (e) => {
            e.stopPropagation();
            const value = option.getAttribute('data-value');
            const label = option.textContent.trim();
            selectOption(value, label);
          });
        });
      }

      if (modal) {
        const modalOptions = modal.querySelectorAll('.ec-representatives-sort__option');
        const currentValue = RepresentativesState.currentSort || 'relevancia';
        modalOptions.forEach(option => {
          const optionValue = option.getAttribute('data-value');
          if (optionValue === currentValue) {
            option.classList.add('ec-representatives-sort__option--selected');
            option.setAttribute('aria-selected', 'true');
            const checkbox = option.querySelector('.ec-representatives-sort__option-checkbox');
            if (checkbox) {
              checkbox.style.backgroundColor = '#086EBB';
              checkbox.style.borderColor = '#086EBB';
            }
          }
          option.addEventListener('click', (e) => {
            e.stopPropagation();
            const value = option.getAttribute('data-value');
            const label = option.querySelector('span:last-child')?.textContent.trim() || option.textContent.trim();
            selectOption(value, label);
          });
        });
      }

      document.addEventListener('click', function(e) {
        if (sortContainer && !sortContainer.contains(e.target)) {
          closeDropdown();
        }
      });
    }

    static sortCards(cards) {
      const sortType = RepresentativesState.currentSort;

      if (sortType === 'relevancia') {
        cards.sort((a, b) => {
          const premiumA = a.getAttribute('data-premium') === 'true';
          const premiumB = b.getAttribute('data-premium') === 'true';
          
          if (premiumA && !premiumB) return -1;
          if (!premiumA && premiumB) return 1;
          
          const indexA = parseInt(a.getAttribute('data-original-index') || '0');
          const indexB = parseInt(b.getAttribute('data-original-index') || '0');
          return indexA - indexB;
        });
        return cards;
      }

      if (sortType === 'nome-az') {
        cards.sort((a, b) => {
          const nomeA = (a.getAttribute('data-nome') || '').toLowerCase();
          const nomeB = (b.getAttribute('data-nome') || '').toLowerCase();
          return nomeA.localeCompare(nomeB, 'pt-BR');
        });
      } else if (sortType === 'nome-za') {
        cards.sort((a, b) => {
          const nomeA = (a.getAttribute('data-nome') || '').toLowerCase();
          const nomeB = (b.getAttribute('data-nome') || '').toLowerCase();
          return nomeB.localeCompare(nomeA, 'pt-BR');
        });
      } else if (sortType === 'mais-antigos' || sortType === 'mais-recentes') {
        cards.sort((a, b) => {
          const indexA = parseInt(a.getAttribute('data-original-index') || '0');
          const indexB = parseInt(b.getAttribute('data-original-index') || '0');
          return sortType === 'mais-antigos' ? indexA - indexB : indexB - indexA;
        });
      }

      return cards;
    }
  }

  class RepresentativesPagination {
    static init() {
      const pagination = document.querySelector('.ec-representatives-pagination');
      if (!pagination || pagination.hasAttribute('data-listeners-attached')) {
        return;
      }
      
      pagination.setAttribute('data-listeners-attached', 'true');
      this.attachPaginationListeners(pagination, RepresentativesState.currentFilterState);
    }

    static attachPaginationListeners(pagination, filterState) {
      pagination.addEventListener('click', (e) => {
        const button = e.target.closest('.ec-representatives-pagination__button[data-page]');
        if (!button || button.disabled) return;

        const page = button.getAttribute('data-page');
        if (page === 'prev' || page === 'next') return;

        this.goToPage(parseInt(page), filterState);
      });

      const prevBtn = pagination.querySelector('.ec-representatives-pagination__button--prev');
      const nextBtn = pagination.querySelector('.ec-representatives-pagination__button--next');

      if (prevBtn) {
        prevBtn.addEventListener('click', (e) => {
          if (prevBtn.disabled) return;
          let page = prevBtn.getAttribute('data-page');
          if (page === 'prev') {
            const activeBtn = pagination.querySelector('.ec-representatives-pagination__button--active');
            if (activeBtn) {
              const currentPage = parseInt(activeBtn.getAttribute('data-page'));
              page = (currentPage - 1).toString();
            } else {
              return;
            }
          }
          const pageNumber = parseInt(page);
          if (!isNaN(pageNumber) && pageNumber >= 1) {
            this.goToPage(pageNumber, filterState);
          }
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', (e) => {
          if (nextBtn.disabled) return;
          let page = nextBtn.getAttribute('data-page');
          if (page === 'next') {
            const activeBtn = pagination.querySelector('.ec-representatives-pagination__button--active');
            if (activeBtn) {
              const currentPage = parseInt(activeBtn.getAttribute('data-page'));
              page = (currentPage + 1).toString();
            } else {
              return;
            }
          }
          const pageNumber = parseInt(page);
          if (!isNaN(pageNumber) && pageNumber >= 1) {
            this.goToPage(pageNumber, filterState);
          }
        });
      }
    }

    static updatePagination(pagination, currentPage, totalPages, filterState) {
      const prevBtn = pagination.querySelector('.ec-representatives-pagination__button--prev');
      const nextBtn = pagination.querySelector('.ec-representatives-pagination__button--next');
      const pageButtons = pagination.querySelectorAll('.ec-representatives-pagination__button--page');
      const ellipsisStart = pagination.querySelector('.ec-representatives-pagination__ellipsis--start');
      const ellipsisEnd = pagination.querySelector('.ec-representatives-pagination__ellipsis--end');

      if (prevBtn) {
        if (currentPage === 1) {
          prevBtn.classList.add('ec-representatives-pagination__button--disabled');
          prevBtn.disabled = true;
        } else {
          prevBtn.classList.remove('ec-representatives-pagination__button--disabled');
          prevBtn.disabled = false;
          prevBtn.setAttribute('data-page', currentPage - 1);
        }
      }

      if (nextBtn) {
        if (currentPage === totalPages) {
          nextBtn.classList.add('ec-representatives-pagination__button--disabled');
          nextBtn.disabled = true;
        } else {
          nextBtn.classList.remove('ec-representatives-pagination__button--disabled');
          nextBtn.disabled = false;
          nextBtn.setAttribute('data-page', currentPage + 1);
        }
      }

      let startPage = Math.max(1, currentPage - 2);
      let endPage = Math.min(totalPages, currentPage + 2);

      if (totalPages > 7) {
        if (currentPage > 4) {
          if (ellipsisStart) ellipsisStart.style.display = 'flex';
          startPage = currentPage - 2;
        } else {
          if (ellipsisStart) ellipsisStart.style.display = 'none';
          startPage = 1;
          endPage = 5;
        }

        if (currentPage < totalPages - 3) {
          if (ellipsisEnd) ellipsisEnd.style.display = 'flex';
          endPage = currentPage + 2;
        } else {
          if (ellipsisEnd) ellipsisEnd.style.display = 'none';
          startPage = totalPages - 4;
          endPage = totalPages;
        }
      } else {
        if (ellipsisStart) ellipsisStart.style.display = 'none';
        if (ellipsisEnd) ellipsisEnd.style.display = 'none';
      }

      pageButtons.forEach(btn => {
        const page = parseInt(btn.getAttribute('data-page'));
        if (page >= startPage && page <= endPage) {
          btn.style.display = 'flex';
          btn.classList.toggle('ec-representatives-pagination__button--active', page === currentPage);
          btn.disabled = (page === currentPage);
          if (page === currentPage) {
            btn.setAttribute('aria-current', 'page');
          } else {
            btn.removeAttribute('aria-current');
          }
        } else {
          btn.style.display = 'none';
        }
      });
    }

    static goToPage(page, filterState) {
      const grid = document.querySelector('.ec-representatives-grid');
      if (!grid) return;

      if (page < 1) {
        page = 1;
      }

      const itemsPerPage = parseInt(grid.getAttribute('data-items-per-page')) || 12;
      const pagination = document.querySelector('.ec-representatives-pagination');

      let visibleCards = [];
      const allCards = grid.querySelectorAll('.ec-representative-card-wrapper');

      allCards.forEach(card => {
        const cardEstado = card.getAttribute('data-estado')?.toUpperCase().trim() || '';
        const shouldShow = !filterState || cardEstado === filterState.toUpperCase().trim();
        if (shouldShow) {
          visibleCards.push(card);
        }
      });

      const totalPages = Math.ceil(visibleCards.length / itemsPerPage);
      
      if (page > totalPages) {
        page = totalPages;
      }

      const startIndex = (page - 1) * itemsPerPage;
      const endIndex = startIndex + itemsPerPage;

      allCards.forEach(card => {
        card.style.display = 'none';
        const cardElement = card.querySelector('.ec-representative-card');
        if (cardElement) {
          cardElement.style.opacity = '0';
        }
      });

      visibleCards.forEach((card, index) => {
        if (index >= startIndex && index < endIndex) {
          const cardElement = card.querySelector('.ec-representative-card');
          if (cardElement) {
            cardElement.style.opacity = '0';
          }
          card.style.display = 'flex';
          
          requestAnimationFrame(() => {
            setTimeout(() => {
              if (cardElement) {
                cardElement.style.opacity = '1';
                cardElement.classList.add('ec-representative-card--fade-in');
              }
            }, (index - startIndex) * 20);
          });
        }
      });

      if (pagination && totalPages > 1) {
        this.updatePagination(pagination, page, totalPages, filterState);
      }
    }
  }

  class RepresentativesManager {
    static collectRepresentativesData() {
      const cards = document.querySelectorAll('.ec-representative-card-wrapper');
      const totalCards = cards.length;
      RepresentativesState.representativesData = Array.from(cards).map((card, index) => {
        if (!card.hasAttribute('data-original-index')) {
          const invertedIndex = totalCards - 1 - index;
          card.setAttribute('data-original-index', invertedIndex.toString());
        }
        return {
          estado: card.getAttribute('data-estado')?.toUpperCase().trim() || '',
          cidade: card.getAttribute('data-cidade') || '',
          endereco: card.getAttribute('data-endereco') || '',
          nome: card.getAttribute('data-nome') || '',
          element: card
        };
      }).filter(rep => rep.estado !== '');
    }

    static showLoading() {
      const loading = document.getElementById('ec-representatives-loading');
      if (loading) {
        loading.style.display = 'flex';
        const overlay = loading.querySelector('.ec-representatives-loading__overlay');
        const spinner = loading.querySelector('.ec-representatives-loading__spinner');
        const spinnerCircle = loading.querySelector('.ec-representatives-loading__spinner-circle');
        if (overlay) overlay.style.display = 'block';
        if (spinner) spinner.style.display = 'block';
        if (spinnerCircle) spinnerCircle.style.display = 'block';
      }
    }

    static hideLoading() {
      const loading = document.getElementById('ec-representatives-loading');
      if (loading) {
        loading.style.display = 'none';
        const overlay = loading.querySelector('.ec-representatives-loading__overlay');
        const spinner = loading.querySelector('.ec-representatives-loading__spinner');
        const spinnerCircle = loading.querySelector('.ec-representatives-loading__spinner-circle');
        if (overlay) overlay.style.display = 'none';
        if (spinner) spinner.style.display = 'none';
        if (spinnerCircle) spinnerCircle.style.display = 'none';
      }
    }

    static cancelSearch() {
      if (RepresentativesState.abortController) {
        RepresentativesState.abortController.abort();
        RepresentativesState.abortController = null;
      }
      this.hideLoading();
    }

    static lockSearchInput() {
      const searchInput = document.getElementById('ec-representatives-search');
      if (searchInput) {
        searchInput.disabled = true;
        RepresentativesState.isSearching = true;
      }
    }

    static unlockSearchInput() {
      const searchInput = document.getElementById('ec-representatives-search');
      if (searchInput) {
        searchInput.disabled = false;
        RepresentativesState.isSearching = false;
      }
    }

    static init() {
      this.collectRepresentativesData();
      RepresentativesSearch.init();
      RepresentativesFiltering.init();
      RepresentativesSorting.init();
      RepresentativesPagination.init();
      this.initCounter();
      this.initClearButton();
      this.initGrid();
    }

    static updateGrid(visibleCount) {
      const grid = document.querySelector('.ec-representatives-grid');
      if (!grid) return;

      const itemsPerPage = parseInt(grid.getAttribute('data-items-per-page')) || 12;
      const currentPage = 1;

      const emptyMessage = grid.querySelector('.ec-representatives-grid__empty');
      const pagination = document.querySelector('.ec-representatives-pagination');

      const allCards = document.querySelectorAll('.ec-representative-card-wrapper');
      const visibleCards = Array.from(allCards).filter(card => {
        const display = window.getComputedStyle(card).display;
        return display !== 'none';
      });

      const totalPages = Math.ceil(visibleCount / itemsPerPage);
      const startIndex = (currentPage - 1) * itemsPerPage;
      const endIndex = startIndex + itemsPerPage;

      if (visibleCount === 0) {
        if (emptyMessage) {
          emptyMessage.style.display = 'block';
        }
        if (pagination) {
          pagination.style.display = 'none';
        }
      } else {
        if (emptyMessage) {
          emptyMessage.style.display = 'none';
        }

        visibleCards.forEach((card, index) => {
          const shouldShow = index >= startIndex && index < endIndex;
          const cardElement = card.querySelector('.ec-representative-card');
          
          if (shouldShow) {
            if (cardElement) {
              cardElement.style.opacity = '0';
            }
            card.style.display = 'flex';
            
            requestAnimationFrame(() => {
              setTimeout(() => {
                if (cardElement) {
                  cardElement.style.opacity = '1';
                  cardElement.classList.add('ec-representative-card--fade-in');
                }
              }, (index - startIndex) * 20);
            });
          } else {
            card.style.display = 'none';
            if (cardElement) {
              cardElement.style.opacity = '0';
              cardElement.classList.remove('ec-representative-card--fade-in');
            }
          }
        });

        if (pagination && totalPages > 1) {
          pagination.style.display = 'flex';
          RepresentativesPagination.updatePagination(pagination, currentPage, totalPages, RepresentativesState.currentFilterState);
        } else if (pagination) {
          pagination.style.display = 'none';
        }
      }
    }

    static initGrid() {
      const grid = document.querySelector('.ec-representatives-grid');
      if (!grid) return;

      const urlParams = new URLSearchParams(window.location.search);
      const filterState = urlParams.get('estado') ? urlParams.get('estado').toUpperCase().trim() : '';

      if (filterState) {
        RepresentativesState.currentFilterState = filterState;
        const filterElement = document.querySelector(`.filter-uf_element[data-value="${filterState}"]`);
        if (filterElement) {
          filterElement.classList.add('active');
        }
        RepresentativesFiltering.filterByState(filterState);
      } else {
        this.updateTitle(null, null, 'all-bold');
        this.applyFilters();
      }
    }


    static getVisibleCount() {
      const grid = document.querySelector('.ec-representatives-grid');
      if (!grid) return 0;
      return Array.from(grid.querySelectorAll('.ec-representative-card-wrapper'))
        .filter(card => {
          const cardEstado = card.getAttribute('data-estado')?.toUpperCase().trim() || '';
          const shouldShow = !RepresentativesState.currentFilterState || cardEstado === RepresentativesState.currentFilterState.toUpperCase().trim();
          return shouldShow;
        }).length;
    }

    static updateCounter(count, location) {
      const counterText = document.getElementById('ec-representatives-counter-text');
      if (!counterText) return;

      const allCards = document.querySelectorAll('.ec-representative-card-wrapper');
      const visibleCards = Array.from(allCards).filter(card => {
        const display = window.getComputedStyle(card).display;
        return display !== 'none';
      });

      const totalCount = count !== undefined ? count : visibleCards.length;
      const profissionalText = totalCount === 1 ? 'profissional' : 'profissionais';
      
      if (location) {
        RepresentativesState.currentSearchLocation = location;
        counterText.innerHTML = `<strong>${totalCount}</strong> ${profissionalText} encontrado${totalCount === 1 ? '' : 's'} próximos a <strong>${location}</strong>`;
      } else if (RepresentativesState.currentSearchLocation) {
        counterText.innerHTML = `<strong>${totalCount}</strong> ${profissionalText} encontrado${totalCount === 1 ? '' : 's'} próximos a <strong>${RepresentativesState.currentSearchLocation}</strong>`;
      } else {
        const estado = RepresentativesState.currentFilterState;
        if (estado) {
          const estadoNome = RepresentativesState.statesMapping[estado] || estado;
          counterText.innerHTML = `<strong>${totalCount}</strong> ${profissionalText} encontrado${totalCount === 1 ? '' : 's'} em <strong>${estadoNome}</strong>`;
        } else {
          counterText.innerHTML = `<strong>${totalCount}</strong> ${profissionalText} encontrado${totalCount === 1 ? '' : 's'}`;
        }
      }
      
      RepresentativesFiltering.updateClearButton();
    }

    static updateTitle(uf, customText, formatType) {
      const titleElement = document.querySelector('.ec-representatives-filter__title');
      if (!titleElement) return;
      
      if (formatType === 'all-bold') {
        titleElement.innerHTML = '<strong>Todos os profissionais credenciados</strong>';
      } else if (formatType === 'cep') {
        const cep = customText || '';
        titleElement.innerHTML = `Busca pelo CEP: <strong>${cep}</strong>`;
      } else if (formatType === 'address') {
        const address = customText || '';
        titleElement.innerHTML = `Profissionais próximos a: <strong>${address}</strong>`;
      } else if (formatType === 'state') {
        const estadoNome = uf ? RepresentativesState.statesMapping[uf] : customText || '';
        titleElement.innerHTML = `Profissionais em: <strong>${estadoNome}</strong>`;
      } else if (customText) {
        titleElement.textContent = customText;
      } else if (uf) {
        const estadoNome = RepresentativesState.statesMapping[uf] || uf;
        titleElement.innerHTML = `Profissionais em: <strong>${estadoNome}</strong>`;
      } else {
        titleElement.innerHTML = '<strong>Todos os profissionais credenciados</strong>';
      }
    }

    static initCounter() {
      const clearLink = document.getElementById('ec-representatives-clear-search-link');
      if (clearLink) {
        clearLink.addEventListener('click', (e) => {
          e.preventDefault();
          this.clearAll();
        });
      }
      this.updateCounter();
    }

    static initClearButton() {
      const clearButton = document.getElementById('ec-representatives-clear-search-btn');
      if (clearButton) {
        clearButton.addEventListener('click', (e) => {
          e.preventDefault();
          this.clearAll();
        });
      }
      RepresentativesFiltering.updateClearButton();
    }

    static clearAll() {
      if (RepresentativesState.searchDebounceTimeout) {
        clearTimeout(RepresentativesState.searchDebounceTimeout);
        RepresentativesState.searchDebounceTimeout = null;
      }
      
      const searchInput = document.getElementById('ec-representatives-search');
      if (searchInput) {
        searchInput.value = '';
      }
      this.unlockSearchInput();
      RepresentativesState.reset();
      
      const typeValueElement = document.getElementById('ec-representatives-type-filter-value');
      if (typeValueElement) {
        typeValueElement.textContent = 'Todos';
      }
      
      const sortValueElement = document.getElementById('ec-representatives-sort-value');
      if (sortValueElement) {
        sortValueElement.textContent = 'Relevância';
      }
      
      RepresentativesFiltering.clearFilters();
      const filterElement = document.querySelector(`.filter-uf_element[data-value=""]`);
      if (filterElement) {
        filterElement.classList.add('active');
      }
      
      this.updateTitle(null, null, 'all-bold');
      this.initGrid();
      this.updateCounter();
      RepresentativesFiltering.updateClearButton();
    }

    static applyFilters() {
      const allCards = document.querySelectorAll('.ec-representative-card-wrapper');
      let visibleCards = Array.from(allCards);

      if (RepresentativesState.currentSearchResults && RepresentativesState.currentSearchResults.length > 0) {
        visibleCards = Array.from(RepresentativesState.currentSearchResults);
      } else {
        visibleCards = visibleCards.filter(card => {
          const cardEstado = card.getAttribute('data-estado')?.toUpperCase().trim() || '';
          if (RepresentativesState.currentFilterState && cardEstado !== RepresentativesState.currentFilterState.toUpperCase().trim()) {
            return false;
          }
          return true;
        });
      }

      if (RepresentativesState.currentFilterType !== 'todos') {
        visibleCards = visibleCards.filter(card => {
          const cardTipos = card.getAttribute('data-tipo') || '';
          const tiposArray = cardTipos.split(',').map(t => t.trim().toLowerCase());
          return tiposArray.includes(RepresentativesState.currentFilterType.toLowerCase());
        });
      }

      const sortedCards = RepresentativesSorting.sortCards(visibleCards);
      
      const grid = document.querySelector('.ec-representatives-grid');
      if (grid) {
        sortedCards.forEach(card => {
          grid.appendChild(card);
        });
      }
      
      allCards.forEach(card => {
        card.style.display = 'none';
        const cardElement = card.querySelector('.ec-representative-card');
        if (cardElement) {
          cardElement.style.opacity = '0';
        }
      });

      sortedCards.forEach((card, index) => {
        const cardElement = card.querySelector('.ec-representative-card');
        if (cardElement) {
          cardElement.style.opacity = '0';
        }
        card.style.display = 'flex';
        
        requestAnimationFrame(() => {
          setTimeout(() => {
            if (cardElement) {
              cardElement.style.opacity = '1';
              cardElement.classList.add('ec-representative-card--fade-in');
            }
          }, index * 20);
        });
      });

      this.updateCounter(sortedCards.length);
      this.updateGrid(sortedCards.length);
    }

    static openMapModal(event, buttonElement) {
      console.log("Modal open");
      if (event) {
        event.preventDefault();
      }

      const cardWrapper = buttonElement.closest('.ec-representative-card-wrapper');
      if (!cardWrapper) return;

      const representative = {
        nome: cardWrapper.getAttribute('data-nome') || '',
        cidade: cardWrapper.getAttribute('data-cidade') || '',
        estado: cardWrapper.getAttribute('data-estado') || '',
        endereco: cardWrapper.getAttribute('data-endereco') || '',
        tipo: cardWrapper.getAttribute('data-tipo') || '',
        premium: cardWrapper.getAttribute('data-premium') === 'true',
        foto: cardWrapper.getAttribute('data-foto') || '',
        nivel: cardWrapper.getAttribute('data-nivel') || '',
        telefone: cardWrapper.getAttribute('data-telefone') || '',
        email: cardWrapper.getAttribute('data-email') || ''
      };

      const modal = document.getElementById('ec-representative-map-modal');
      if (!modal) return;

      const enderecoCompleto = `${representative.endereco} ${representative.cidade} - ${representative.estado}`.trim();
      const encodedAddress = encodeURIComponent(enderecoCompleto);
      
      const googleMapsUrl = `https://www.google.com/maps?q=${encodedAddress}`;
      const wazeUrl = `https://waze.com/ul?q=${encodedAddress}`;
      const mapEmbedUrl = `https://www.google.com/maps?q=${encodedAddress}&output=embed`;

      const iframe = document.getElementById('ec-representative-map-modal-iframe');
      if (iframe) {
        iframe.src = mapEmbedUrl;
      }

      const image = document.getElementById('ec-representative-map-modal-image');
      const imagePlaceholder = document.getElementById('ec-representative-map-modal-image-placeholder');
      if (representative.foto) {
        if (image) {
          image.src = representative.foto;
          image.alt = representative.nome || 'Representante';
          image.style.display = 'block';
        }
        if (imagePlaceholder) imagePlaceholder.style.display = 'none';
      } else {
        if (image) image.style.display = 'none';
        if (imagePlaceholder) {
          imagePlaceholder.textContent = (representative.nome || 'R').charAt(0).toUpperCase();
          imagePlaceholder.style.display = 'flex';
        }
      }

      const badgesContainer = document.getElementById('ec-representative-map-modal-badges');
      if (badgesContainer) {
        let badgesHTML = '';
        if (representative.tipo) {
          const tipos = representative.tipo.split(',').map(t => t.trim()).filter(t => t);
          tipos.forEach(tipo => {
            badgesHTML += `<span class="ec-representative-map-modal__info-badge ec-representative-map-modal__info-badge--tipo-${tipo}">${tipo}</span>`;
          });
        }
        if (representative.premium) {
          badgesHTML += '<span class="ec-representative-map-modal__info-badge ec-representative-map-modal__info-badge--premium">Premium</span>';
        }
        badgesContainer.innerHTML = badgesHTML;
      }

      const nameEl = document.getElementById('ec-representative-map-modal-name');
      if (nameEl) nameEl.textContent = representative.nome || '';

      const cidadeEstado = `${representative.cidade || ''}${representative.cidade && representative.estado ? ' - ' : ''}${representative.estado || ''}`.trim();
      this.updateDetail('nivel', representative.nivel);
      this.updateDetail('cidade', cidadeEstado);
      this.updateDetail('endereco', representative.endereco);
      this.updateDetail('telefone', representative.telefone);
      this.updateDetail('email', representative.email);

      const googleMapsLink = document.getElementById('ec-representative-map-modal-google-maps');
      const wazeLink = document.getElementById('ec-representative-map-modal-waze');
      if (googleMapsLink) googleMapsLink.href = googleMapsUrl;
      if (wazeLink) wazeLink.href = wazeUrl;

      modal.setAttribute('data-open', 'true');
      document.body.style.overflow = 'hidden';
    }

    static updateDetail(field, value) {
      const container = document.getElementById(`ec-representative-map-modal-${field}`);
      const valueEl = document.getElementById(`ec-representative-map-modal-${field}-value`);
      if (container && valueEl) {
        if (value) {
          container.style.display = 'flex';
          valueEl.textContent = value;
        } else {
          container.style.display = 'none';
        }
      }
    }

    static closeMapModal() {
      const modal = document.getElementById('ec-representative-map-modal');
      if (modal) {
        modal.setAttribute('data-open', 'false');
        const iframe = document.getElementById('ec-representative-map-modal-iframe');
        if (iframe) {
          iframe.src = '';
        }
        document.body.style.overflow = '';
      }
    }

    static initMapModal() {
      const modal = document.getElementById('ec-representative-map-modal');
      if (!modal) return;

      const closeButton = document.getElementById('ec-representative-map-modal-close');
      const overlay = modal.querySelector('.ec-representative-map-modal__overlay');
      
      if (closeButton) {
        closeButton.addEventListener('click', (e) => {
          e.preventDefault();
          this.closeMapModal();
        });
      }
      
      if (overlay) {
        overlay.addEventListener('click', () => {
          this.closeMapModal();
          });
        }
      }
    }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      RepresentativesManager.init();
      RepresentativesManager.initMapModal();
    });
  } else {
    RepresentativesManager.init();
    RepresentativesManager.initMapModal();
  }

  window.RepresentativesManager = RepresentativesManager;
})();
